'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAttemptingMultiSelect = undefined;

var _keyboardUtility = require('../../utils/keyboard/keyboardUtility');

var isAttemptingMultiSelect = exports.isAttemptingMultiSelect = function isAttemptingMultiSelect(event) {
  return (0, _keyboardUtility.hasShiftKey)(event) || (0, _keyboardUtility.hasCommandModifier)(event);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/selection/selectionUtils.js
// module id = 458
// module chunks = 0